
import './Modal.css';
import React, {useEffect, useRef} from 'react';
function Modal ({children, name, onClose, id, modalClass, autoClose,style}) {

    const ref = useRef();

    const onClick = (event) => {
        // voir https://tekolio.com/how-to-detect-a-click-outside-of-a-react-component-using-hooks/?trk=article-ssr-frontend-pulse_little-text-block
        if (event.target.closest('.autocomplete-items')) return;

        if (ref.current.contains(event.target) == false && document.querySelectorAll('[id^="_nice_modal"]').length == 1) {
            onClose();
            return;
          }

        if(autoClose == false || event.target.id != id) {
            return null;
        }
        onClose();
    }

    useEffect(() => {
        document.addEventListener("mousedown", onClick);
        return () => {
          document.removeEventListener("mousedown", onClick);
        };
      });
    return (
        <div id={id} ref={ref} className={modalClass  + " " + name} onMouseDown={onClick}>
            <div className={"modal-container " + name} style={style}>
                <div className="modal-info flex-column">
                    {children}
                </div>
            </div>
        </div>
    );
}

Modal.defaultProps = { modalClass : 'modal', closeTimer : 300, name : 'default', autoClose : true };

export default Modal;